import { Product } from 'common/Products/types'

export const getCardMaskEnd = (card_num: string) => card_num.substr(card_num.length - 10)

// A plan a customer can renew onto by card. The recharge API rejects hidden plans, and the
// products store also holds the customer's own (possibly hidden) schedule products.
export const isRenewablePlan = (plan?: Product): plan is Product =>
  !!plan && plan.visible && !plan.new_customer_only
